var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33398 15H16.084",
    stroke: "#8278F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.709 2.62517C13.0074 2.3268 13.412 2.15918 13.834 2.15918C14.0429 2.15918 14.2498 2.20033 14.4428 2.28029C14.6359 2.36024 14.8112 2.47743 14.959 2.62517C15.1067 2.77291 15.2239 2.9483 15.3039 3.14132C15.3838 3.33435 15.425 3.54124 15.425 3.75017C15.425 3.9591 15.3838 4.16599 15.3039 4.35902C15.2239 4.55204 15.1067 4.72743 14.959 4.87517L5.58398 14.2502L2.58398 15.0002L3.33398 12.0002L12.709 2.62517Z",
    fill: "#E5E5E7",
    stroke: "#8278F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.205b50a02480c354d5da3464e6aa5268.svg";
export { ForwardRef as ReactComponent };